window.DealResponseModal = {
    init(modalEl) {
        this.handleShow(modalEl);
        this.handleChange(modalEl);
        this.handleButtonClicks(modalEl);
    },

    handleShow(modalEl) {
        var $modal = $(modalEl);
        $modal.on("show.bs.modal", function () {
            $modal.find('input[type="checkbox"][name="reason"]').prop("checked", false);
            $modal.find("#other-reason-input").hide();
            $modal.find("#other_reason").val("");
        });
    },

    handleChange(modalEl) {
        var $modal = $(modalEl);
        $modal.on("change", 'input[type="checkbox"][name="reason"]', function () {
            var $changed = $(this);

            if (this.checked) {
                $modal.find('input[type="checkbox"][name="reason"]').not(this).prop("checked", false);

                if ($changed.data("reason") === "other") {
                    $modal.find("#other-reason-input").show();
                } else {
                    $modal.find("#other-reason-input").hide();
                }
            } else {
                $modal.find("#other-reason-input").hide();
            }
        });
    },

    handleButtonClicks(modalEl) {
        var $modal = $(modalEl);
        $modal.find("#deal-response-modal-not-interested-btn").on("click", function () {
            const reason = $modal.find('input[type="checkbox"][name="reason"]:checked').data('reason');
            const reasonText = $modal.find("#other_reason").val();
            const dealId = $modal.find('#deal_id').val();
            const aiMatchId = $modal.find('#data_system_deal_match_id').val();

            $.ajax({
                url: `/deal_extended_suppliers`,
                method: 'POST',
                data: {
                    deal_id: dealId,
                    data_system_deal_match_ids: [aiMatchId],
                    reason: reason || 'not_interested',
                    reason_text: reasonText,
                },
                success: function (data) {
                    $modal.modal('hide');
                },
                error: function (error) {
                    console.error('Error creating extended suppliers:', error);
                }
            })
        });
    }
};
